import {
  library,
  IconProp,
  IconDefinition,
} from '@fortawesome/fontawesome-svg-core'
import {
  faFacebookF,
  faLinkedinIn,
  faTiktok,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import {
  faEnvelope,
  faXmark,
  faPlus,
  faPlay,
  faCheckCircle as faCheckCircleSolid,
  faGlobe,
  faPause,
  faExpand,
  faVolumeHigh,
  faVolumeLow,
  faAngleRight,
  faAngleLeft,
  faChevronDown as faChevronDownSolid,
  faChevronUp as faChevronUpSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faVolumeMute,
  faCompress,
  faDownload as faDownloadSolid,
  faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons'
import {
  faArrowLeftLong,
  faExclamationCircle,
  faQuestionCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faArrowRight,
  faCalendarAlt,
  faHourglass,
  faLockKeyhole,
  faCheckCircle,
  faTurnDownRight,
  faDownload,
  faBooks,
  faBookAlt,
  faXmark as faXmarkLight,
  faSignalStream,
  faTrashCan,
  faCartShopping,
  faWallet,
  faCreditCard,
  faBadgeDollar,
  faTriangleExclamation,
  faCircleInfo,
  faFile,
  faFileSignature,
  faMicrophone,
  faFileWord,
  faPlay as faPlayLight,
  faImage,
  faVideo,
  faFilePdf,
  faFileSpreadsheet,
  faUserGraduate,
  faDoorOpen,
  faUser,
  faUsdCircle,
  faEnvelope as faEnvelopeLight,
  faHouse,
  faBagShopping,
  faUserHeadset,
  faUserCircle,
  faTrophyStar,
  faEye,
  faExpand as faExpandLight,
  faGear,
  faSliders,
  faWifiSlash,
  faGlobe as faGlobeLight,
  faGlobePointer,
  faEye as faEyeLight,
  faEyeSlash as faEyeSlashLight,
  faFileContract,
  faShieldHalved,
} from '@fortawesome/pro-light-svg-icons'
import {
  FontAwesomeIcon,
  FontAwesomeIconStyle,
} from '@fortawesome/react-native-fontawesome'
import { useTheme } from 'tamagui'
import {
  faWhatsappSolid,
  faInstagramSolid,
  faTwitterSolid,
  faAvancar10s,
  faVoltar10s,
  faPictureInPicture,
  faVideoSpeed,
} from '@awesome.me/kit-9f9823c2a0/icons/modules/kit/custom'

const CUSTOM_ICONS = {
  'whatsapp-solid': faWhatsappSolid,
  'twitter-solid': faTwitterSolid,
  'instagram-solid': faInstagramSolid,
  avancar10s: faAvancar10s,
  voltar10s: faVoltar10s,
  'picture-in-picture': faPictureInPicture,
  'video-speed': faVideoSpeed,
}

library.add(
  faSliders,
  faVideoSpeed,
  faAvancar10s,
  faVoltar10s,
  faPictureInPicture,
  faVolumeHigh,
  faVolumeLow,
  faVolumeMute,
  faArrowLeftLong,
  faExclamationCircle,
  faVideo,
  faFilePdf,
  faExpand,
  faCompress,
  faFileSpreadsheet,
  faGear,
  faChevronDown,
  faChevronUp,
  faBagShopping,
  faChevronLeft,
  faDoorOpen,
  faEnvelopeLight,
  faXmarkLight,
  faPause,
  faUserGraduate,
  faChevronRight,
  faCalendarAlt,
  faHouse,
  faUser,
  faUsdCircle,
  faHourglass,
  faArrowRight,
  faSignalStream,
  faCircleInfo,
  faPlayLight,
  faGlobe,
  faFile,
  faFileSignature,
  faMicrophone,
  faFileWord,
  faPlay,
  faImage,
  faTrashCan,
  faCartShopping,
  faWallet,
  faCreditCard,
  faBadgeDollar,
  faTriangleExclamation,
  faLockKeyhole,
  faCheckCircle,
  faCheckCircleSolid,
  faTurnDownRight,
  faDownload,
  faBooks,
  faBookAlt,
  faFacebookF,
  faLinkedinIn,
  faTiktok,
  faXTwitter,
  faYoutube,
  faEnvelope,
  faXmark,
  faPlus,
  faPlay,
  faUserHeadset,
  faUserCircle,
  faAngleLeft,
  faAngleRight,
  faTrophyStar,
  faChevronDownSolid,
  faChevronUpSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faEye,
  faExpandLight,
  faDownloadSolid,
  faWifiSlash,
  faGlobeLight,
  faEyeLight,
  faEyeSlashLight,
  faGlobePointer,
  faFileContract,
  faShieldHalved,
  faArrowUpRightFromSquare,
  faQuestionCircle,
)

export function HeroIcon({
  icon,
  size = 24,
  color = '$neutral-200',
  style,
}: {
  icon: IconProp | string
  size?: number
  color?: string
  style?: FontAwesomeIconStyle
}) {
  const theme = useTheme()
  const setIcons = () => {
    if (typeof icon === 'string' && icon in CUSTOM_ICONS) {
      return CUSTOM_ICONS[icon as keyof typeof CUSTOM_ICONS] as IconDefinition
    }

    return icon as IconProp
  }
  const styleObject = Object.assign({}, style, { pointerEvents: 'none' })

  return (
    <FontAwesomeIcon
      icon={setIcons()}
      size={size}
      color={theme[color]?.val || color}
      style={styleObject}
    />
  )
}
